/* istanbul ignore file */
// Entry point
module.exports = require('./src/Factory');
